/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsConfigGcpAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsConfigGcpAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsConfigGcpAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsConfigGcpAdvisorResource>): RecommendationForFinopsConfigGcpAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsConfigGcpAdvisorResource(), model);
        RecommendationForFinopsConfigGcpAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsConfigGcpAdvisorResource>): RecommendationForFinopsConfigGcpAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsConfigGcpAdvisorResource.newInstance(<RecommendationForFinopsConfigGcpAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsConfigGcpAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsConfigGcpAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsConfigGcpAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsConfigGcpAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
